import { useTranslation } from "@coworker/locales";
import departmentNamingExceptions from "../constants/refillAreaNamingExceptions";
import { useMemo } from "react";

const useRefillAreaName = (hfb: string) => {
  const { t } = useTranslation();

  const departmentName = useMemo(() => {
    if (!hfb || !hfb.length) return "";

    if (departmentNamingExceptions.includes(hfb)) {
      return t(`hfb${hfb}String`);
    }

    if (hfb === "SFM") {
      return t("otherAreaSwedishFoodMarketString");
    }

    if (hfb === "MOW") {
      return t("markethallOpenTheWalletString");
    }

    if (hfb === "SOW") {
      return t("showroomOpenTheWalletString");
    }

    return `HFB ${hfb} - ${t(`hfb${hfb}String`)}`;
  }, [hfb, t]);

  return departmentName;
};

export default useRefillAreaName;
